module.exports = __webpack_public_path__ + "img/2_59.5834ac5d.png";